import { Modal } from 'antd';
import CustomButton from '../../../../../../v2-components/Antd/Button';
import './style.scss'; // Asegúrate de tener el estilo adecuado

const QuotationFailModal = ({ visible, onCancel, onDeleteCart }) => {
  return (
    <Modal
      title="Ups!"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <CustomButton key="cancel" className="ph-btn ph-btn--cancel" onClick={() => onDeleteCart(false)}>
          <p style={{marginLeft: '-2px'}}>Borrar bolsa</p>
        </CustomButton>,
        <CustomButton key="accept" className="ph-btn ph-btn--accept" onClick={onCancel}>
          Continuar
        </CustomButton>,
      ]}
      className="delivery-modal" 
    >
      <div>
        <p>Tienes una cotización abierta, puedes pagarla o borrar los productos de la bolsa para agregar productos de una nueva cotización.</p>
      </div>
    </Modal>
  );
};

export default QuotationFailModal;
